import React, { Component } from 'react'
import { observer } from 'mobx-react'
import i18n from 'i18next'

import Button from '../../../UniformComponents/Button'
import DistributionNavigation from '../DistributionNavigation'
import DistributeEmptyState from '../../../UniformComponents/DistributeEmptyState'
import DataTable from '../../DataTable'
import Panel from '../../../UniformComponents/Panel'
import CampaignLinksModal from './CampaignLinksModal'
import DeleteModal from '../Modal/DeleteModal'
import Typography from '../../../UniformComponents/Typography'

@observer
class CampaignLinks extends Component {
    constructor(props) {
        super(props)
        const { distributeStore } = props

        distributeStore.campaignType = 'campaign'
        distributeStore.getCampaigns()
    }

    getColumns = () => {
        const { distributeStore, store } = this.props
        const { survey } = store

        return [
            {
                key: 'campaigntitle',
                name: 'Title',
                dataTransform: (value, row) => (
                    [
                        <Typography type="b">{value}</Typography>,
                        <div key={`fc_${value}`} className="campaign-links-link-input">
                            <i className="far fa-link-horizontal" />

                            <Typography type="tiny">
                                {survey.getCampaignLink(row.uuid, row.langCode, store.useLatestUI)}
                            </Typography>
                        </div>,
                    ]
                ),
            },
            {
                key: 'campaignId',
                name: '',
                dataTransform: (_, row) => (
                    <div className="campaign-links-table-actions">
                        <i className="fal fa-copy" onClick={() => store.copyText(survey.getCampaignLink(row.uuid, row.langCode, store.useLatestUI), i18n.t('s_new_campaign_label_campaign_link'))} />
                        <i className="fal fa-edit" onClick={(e) => distributeStore.editCampaign(e, row)} />
                        <i className="fal fa-circle-xmark" onClick={() => distributeStore.showDeleteModal(row.campaignId)} />
                    </div>
                ),
                cellClass: 'center w50 pointer',
            },
        ]
    }

    render() {
        const { store, distributeStore } = this.props
        const { filteredList, filterText } = distributeStore

        return (
            <div className="email-landing-content">
                <DistributionNavigation store={distributeStore} survey={store.survey} />

                <div className="email-landing-right-container">
                    <Panel style={{ padding: 20, overflow: 'visible' }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <h2>{i18n.t('distributionCampaignLinks.title')}</h2>

                            <Button
                                cssClass="regular tertiary"
                                onClick={distributeStore.showCampaignModal}
                                icon="fal fa-link-horizontal"
                                label={i18n.t('distributionCampaignLinks.create')}
                            />
                        </div>
                    </Panel>

                    {!filteredList.length && !filterText.length
                        ? (
                            <DistributeEmptyState
                                title={i18n.t('distributionCampaignLinks.emptyStateText')}
                                subtext={i18n.t('distributionCampaignLinks.emptyStateSubText')}
                                ctaText={i18n.t('distributionCampaignLinks.create')}
                                icon="fal fa-link-horizontal"
                                ctaIcon="fal fa-link-horizontal"
                                onClick={distributeStore.showCampaignModal}
                            />
                        )
                        : (
                            <Panel style={{ padding: '0px' }}>
                                <DataTable
                                    store={distributeStore}
                                    dataSet={filteredList}
                                    inMemory
                                    columns={this.getColumns()}
                                />
                            </Panel>
                        )}
                </div>

                <CampaignLinksModal distributeStore={distributeStore} />
                <DeleteModal distributeStore={distributeStore} />
            </div>
        )
    }
}

export default CampaignLinks
